import type { ReactNode } from "react";
import { cx } from "../../lib/cx";

/**
 * A screen's own scroll region, with the `a-scroll` look, and the padding
 * that keeps content clear of the phone tab bar. A2's `Scroll`.
 *
 * `restorationId` becomes `data-scroll-restoration-id` on the element that
 * scrolls, which is what the router's scroll restoration (T10) keys on: going
 * back to a screen puts it where it was. Give each screen a stable id of its
 * own — two regions sharing one would restore each other's offset.
 */

export interface ScrollProps {
  children: ReactNode;
  /** Classes for the inner column, not the scroller. */
  className?: string;
  restorationId: string;
  /** The wider column (1180 px on desktop instead of 920 px). */
  wide?: boolean;
}

export function Scroll({
  restorationId,
  wide,
  className,
  children,
}: ScrollProps) {
  return (
    <div className="a-scroll h-full" data-scroll-restoration-id={restorationId}>
      <div
        className={cx(
          "mx-auto w-full px-5 pt-6 pb-36 lg:px-10 lg:pt-10 lg:pb-14",
          wide ? "max-w-295" : "max-w-230",
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}
